import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, BookOpen, PenLine, Heart, Target } from "lucide-react";

const items = [
    { to: "/", label: "Home", icon: Home, testid: "nav-home", exact: true },
    { to: "/read", label: "Bible", icon: BookOpen, testid: "nav-bible" },
    { to: "/journal", label: "Journal", icon: PenLine, testid: "nav-journal", matches: ["/journal", "/notes"] },
    { to: "/prayer", label: "Pray", icon: Heart, testid: "nav-prayer", accent: "plum" },
    { to: "/goals", label: "Goals", icon: Target, testid: "nav-goals" },
];

function isActive(item, path) {
    if (item.exact) return path === item.to;
    if (item.matches) return item.matches.some(m => path === m || path.startsWith(m + "/"));
    return path === item.to || path.startsWith(item.to + "/");
}

export default function BottomNav() {
    const loc = useLocation();
    return (
        <nav
            data-testid="bottom-nav"
            className="fixed bottom-0 inset-x-0 z-30 lg:hidden bg-white/95 backdrop-blur-xl border-t border-ink-10 max-w-md md:max-w-xl mx-auto"
        >
            <ul className="flex items-stretch justify-around">
                {items.map(item => {
                    const active = isActive(item, loc.pathname);
                    const Icon = item.icon;
                    const activeColor = item.accent === "plum" ? "text-plum" : "text-moss-deep";
                    return (
                        <li key={item.to} className="flex-1">
                            <NavLink
                                to={item.to}
                                data-testid={item.testid}
                                className={
                                    "flex flex-col items-center justify-center gap-1 py-2.5 min-h-[56px] font-ui text-[11px] transition " +
                                    (active ? activeColor : "text-ink-70 hover:text-ink")
                                }
                            >
                                <Icon size={20} className={active ? activeColor : "text-ink-40"} />
                                {item.label}
                            </NavLink>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}

export function DesktopSideNav() {
    return (
        <nav className="hidden lg:flex flex-col gap-1 px-3 py-4 border-b border-ink-10">
            {items.map(item => {
                const Icon = item.icon;
                return (
                    <NavLink
                        key={item.to}
                        to={item.to}
                        end={item.exact}
                        data-testid={`side-${item.testid}`}
                        className={({ isActive: navActive }) =>
                            "flex items-center gap-2.5 px-3 py-2 rounded-lg font-ui text-[13px] transition " +
                            (navActive
                                ? (item.accent === "plum" ? "bg-plum text-white" : "bg-moss text-white")
                                : "text-ink-70 hover:bg-moss/10 hover:text-moss-deep")
                        }
                    >
                        <Icon size={16} />
                        {item.label}
                    </NavLink>
                );
            })}
        </nav>
    );
}

export { items as NAV_ITEMS };
